module.exports = require('./dist/ReactCrop');



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-image-crop/index.js
// module id = 1518
// module chunks = 93